import { BinaryWriter } from "../binary.js";
import { ServerOp } from "../opcodes.js";
export function encodeTileUpdate(packet, writer = new BinaryWriter(8)) {
    writer
        .u8(ServerOp.TileUpdate)
        .u8(packet.z)
        .u16(packet.x)
        .u16(packet.y)
        .u8(packet.tile);
    return writer;
}
export function decodeTileUpdate(reader) {
    return {
        z: reader.u8(),
        x: reader.u16(),
        y: reader.u16(),
        tile: reader.u8(),
    };
}
//# sourceMappingURL=tile-update.js.map